import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import VisionStatement from '../components/VisionStatement';
import ServicesGrid from '../components/ServicesGrid';
import OpportunitiesToggle from '../components/OpportunitiesToggle';
import ExploreByCountry from '../components/ExploreByCountry';
import IndiaRelocationCallout from '../components/IndiaRelocationCallout';
import AccreditationStrip from '../components/AccreditationStrip';
import TestimonialsCarousel from '../components/TestimonialsCarousel';
import Footer from '../components/Footer';
import WhatsAppWidget from '../components/WhatsAppWidget';
import NewsletterModal from '../components/NewsletterModal';

export default function HomePage() {
  return (
    <div className="bg-[#f7f9fb] text-[#191c1e] font-['Plus_Jakarta_Sans']">
      <Navbar />
      <Hero />
      <VisionStatement />
      <ServicesGrid />
      <OpportunitiesToggle />
      <ExploreByCountry />
      <IndiaRelocationCallout />
      {/* <AccreditationStrip /> */}
      <TestimonialsCarousel />
      <Footer />
      <WhatsAppWidget />
      <NewsletterModal />
    </div>
  );
}